import { createAction } from '@reduxjs/toolkit';

const ACTION_PREFIX = 'login';

export const submitLogin = createAction(`${ACTION_PREFIX}/SUBMIT_LOGIN`);
export const submitLoginSucceeded = createAction(`${ACTION_PREFIX}/SUBMIT_LOGIN_SUCCEEDED`);
export const submitLoginFailed = createAction(`${ACTION_PREFIX}/SUBMIT_LOGIN_FAILED`);
export const setRequiresCaptcha = createAction(`${ACTION_PREFIX}/SET_REQUIRES_CAPTCHA`);
export const updateFields = createAction(`${ACTION_PREFIX}/UPDATE_FIELDS`);

export const setRequires2fa = createAction(`${ACTION_PREFIX}/SET_REQUIRES_2FA`);
export const verify2fa = createAction(`${ACTION_PREFIX}/VERIFY_2FA`);
export const verify2faFailed = createAction(`${ACTION_PREFIX}/VERIFY_2FA_FAILED`);
export const resend2fa = createAction(`${ACTION_PREFIX}/RESEND_2FA`);
export const resend2faSucceeded = createAction(`${ACTION_PREFIX}/RESEND_2FA_SUCCEEDED`);
export const resend2faFailed = createAction(`${ACTION_PREFIX}/RESEND_2FA_FAILED`);
export const reset2fa = createAction(`${ACTION_PREFIX}/RESET_2FA`);

export const LoginActions = {
  submitLogin,
  submitLoginSucceeded,
  submitLoginFailed,
  setRequiresCaptcha,
  updateFields,
  setRequires2fa,
  verify2fa,
  verify2faFailed,
  resend2fa,
  resend2faSucceeded,
  resend2faFailed,
  reset2fa,
};
